'use strict';


/**
 * @see https://vuejs.org/guide/transitions.html#CSS-Transitions
 */
export default class HintTransition {
  /**
   * @param {String} baseClass
   */
  constructor(baseClass) {
    this.base = baseClass;
  }
  get transition() {
    return this.base + '-transition';
  }
  get mouseOver() {
    return this.base + '-mouseover';
  }
  get mouseOut() {
    return this.base + '-mouseout';
  }
}


// WEBPACK FOOTER //
// ./src/js/classes/HintTransition.js